import { createSelector } from 'reselect';
import { Filters, NotificationsState } from './types';

/**
 * Selector for the notification state.
 */
export const notificationCenterSelector = (state: {
  notifications: NotificationsState;
}): NotificationsState => state.notifications;

/**
 * Selects total "unread" notifications
 */
export const selectUnreadNotificationsCount = createSelector(
  [notificationCenterSelector],
  (state) => state?.notificationCount.totalUnread,
);

/**
 * Selects the list of notifications given  the curren filters
 */
export const selectNotifications = createSelector(
  [notificationCenterSelector],
  (state) => state.notifications,
);

/**
 * Selects filters for notifications
 */
export const selectNotificationCenterFilters = createSelector(
  [notificationCenterSelector],
  (state): Filters => state.filters,
);

/**
 * Selects loading state for notifications
 */
export const selectNotificationsIsLoading = createSelector(
  [notificationCenterSelector],
  (state) => state.isLoading,
);
